import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function loadAgencyDashboardApi(agency_id) {
  try {
    const fd = new FormData();

    fd.append("agency_id", agency_id);

    const res = await axios.post(
      `${apiBaseUrl}agencyapis/dashboard_stats`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;
  } catch {
    return { status: false };
  }
}

export async function discoverCreatorsApi(payload) {
  try {
    const fd = new FormData();

    fd.append("agency_id", payload.agency_id || "");
    fd.append("page_no", payload.page_no || "0");

    fd.append("search", payload.search || "");
    fd.append("platform", payload.platform || "");
    fd.append("category", payload.category || "");
    fd.append("audience", payload.audience || "");

    const res = await axios.post(
      `${apiBaseUrl}agencyapis/discover_creators`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return res.data;

  } catch {
    return { status: false };
  }
}

